import {autoChangeBanners} from './banners';
import lazySizes from 'lazysizes';

lazySizes.cfg.loadMode = 1;
lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.init = false;
lazySizes.cfg.loadHidden = true;

(() => {

    function loadImages(images) {

        if (typeof images !== 'undefined') {
            try {
                $.each(images, function (idx, img) {
                    lazySizes.loader.unveil(img)
                });
            } catch (err) {

            }
        }

        lazySizes.init();
    }

    loadImages();

    $.each($('.bnrs-group'), function (index, group) {
        let timeout = parseInt($(group).data('timeout'), 10);
        if (typeof timeout !== 'number' || isNaN(timeout)) {
            timeout = 10;
        }
        if (timeout < 5) {
            timeout = 5;
        }
        timeout = timeout * 1000;
        timeout = 7000;
        let _interval = setInterval(function () {
            let _promise = autoChangeBanners($(group));
            _promise.then(function () {
                if (lazySizes.cfg.loadHidden !== true) {
                    lazySizes.cfg.loadHidden = true;
                }
                loadImages($(group).find('img'));
            }).catch(function () {
                if (_interval) {
                    clearInterval(_interval);
                }
            });
        }, timeout);

    });

    $('.js-new-banners').each(function () {
        let _bannersGroup = $(this);
        let _activeIndex = 0;
        let _banners = _bannersGroup.find('.js-new-banner');
        if (_banners.length > 1) {
            let timeout = 7000;
            setInterval(function () {
                _activeIndex++;
                if (_activeIndex > _banners.length - 1) {
                    _activeIndex = 0;
                }
                _banners.hide();
                _banners.eq(_activeIndex).show();
                $.each(_banners.eq(_activeIndex).find('img'), function (idx, img) {
                    let _img = $(img);
                    if (!_img.hasClass('lazyloaded')) {
                        lazySizes.loader.unveil(img)
                    }
                });
            }, timeout);
        }
    });

})();
